import {
  CFormCheck,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { faPercent, faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import PromptModal from "../../components/modals/PromptModal";
import { DELETE_ACTIONS } from "../../config/constants";
import { colors } from "../../config/theme";
import { getBadgeClassNameByStatus } from "../../helpers/colors";
import { RideStatus, RideStatusLabels } from "../../helpers/enums";
import {
  formatDateString,
  isNotEmpty,
  paymentMethodHelper,
} from "../../helpers/general";
import { useRides } from "../../hooks/useRides";
import { ProfilePictureAvatar } from "../../components/taxi/Profile_picture_avatar";

interface Props {
  riders: Ride[];
  onRiderSelect?: React.Dispatch<BulkDeleteActions>;
  showDriver?: boolean;
  selectedRides?: string[];
  ShowSelectCount?: boolean;
}

interface TableBodyProps {
  ride: Ride;
  showDriver?: boolean;
  deletedList: React.Dispatch<BulkDeleteActions>;
  selectedRides: string[];
}

const ONE_KILOMETER = 1000;
function metersToKilometers(meters: number): number {
  return meters < ONE_KILOMETER ? meters : meters / ONE_KILOMETER;
}

function TableBodyRowContent({
  ride,
  deletedList,
  showDriver,
  selectedRides,
}: TableBodyProps) {
  const [showModal, setShowModal] = useState(false);
  const { removeRide } = useRides();

  const isChecked = selectedRides.includes(ride.id);

  const toggleCheckBox = useCallback(
    (state: boolean) => {
      if (state) {
        deletedList({ type: DELETE_ACTIONS.ADD, id: ride.id });
      } else {
        deletedList({ type: DELETE_ACTIONS.REMOVE, id: ride.id });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ride.id],
  );

  const discountAmount = ride?.priceCalculation?.coupon?.isCouponApplied
    ? +ride?.originalFare - ride?.priceCalculation?.coupon?.fareAfterCoupon
    : 0;

  const disableCheckbox =
    !ride.metaData?.validRide ||
    (ride?.metaData?.driverPayment?.paid &&
      (ride?.priceCalculation?.coupon?.isCouponApplied
        ? ride?.metaData?.couponDiscount?.paid
        : true));

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className="p-3 text-sm">
        {!showDriver && (
          <CFormCheck
            label=""
            defaultChecked={isChecked}
            onChange={(e) => toggleCheckBox(e.target.checked)}
            color={colors.yellow}
            disabled={disableCheckbox || ride.status !== RideStatus.COMPLETED}
          />
        )}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        <Link
          to={`/rides/${ride?.id}/ridedetails`}
          state={{ ride: ride }}
          className="p-2 text-sm"
        >
          {ride?.reference}
        </Link>
      </CTableDataCell>
      <CTableDataCell>
        <div className="p-2 text-sm">
          {formatDateString(ride.createdAt)} -{" "}
          {format(new Date(ride.createdAt), "HH:mm")}
        </div>
        {ride?.priceCalculation?.coupon?.isCouponApplied && (
          <div
            className=" d-flex align-items-center justify-content-center "
            style={{
              top: "5px",
              left: "10px",
              background: "linear-gradient(45deg, #FF7722, #FFB800)",
              padding: "2px 4px",
              margin: "0px 25px",
              borderRadius: "30px",
              fontSize: "1rem",
              color: "white",
            }}
          >
            -{ride?.priceCalculation?.coupon?.couponPercentage}{" "}
            <FontAwesomeIcon icon={faPercent} className="me-2" />
          </div>
        )}
      </CTableDataCell>

      {showDriver && (
        <CTableDataCell className="px-3 text-sm">
          <div className="d-flex align-items-center gap-3">
            {/* <CFormCheck
            id="flexCheckDefault"
            label=""
            defaultChecked={isChecked}
            onChange={e => setIsChecked(e.target.checked)}
            color={colors.yellow}
          /> */}
            {ride?.driver && (
              <>
                <ProfilePictureAvatar
                  profilePicture={ride?.driver?.profilePicture}
                  fullName={ride?.driver?.fullName}
                  isOnline={ride?.driver?.driverProfile?.isOnline}
                />
                <Link
                  to={`/drivers/${ride.driver?.id}`}
                  className="fw-bold m-0 text-capitalize"
                >
                  {ride.driver?.fullName}
                </Link>
              </>
            )}
          </div>
        </CTableDataCell>
      )}
      <CTableDataCell className="px-3 text-sm">
        {!isNotEmpty(ride.user) ? (
          <div className="d-flex align-items-center gap-3 mt-2">
            <span>
              {" "}
              <FontAwesomeIcon icon={faUserSlash} /> Le compte utilisateur a été
              supprimé
            </span>
          </div>
        ) : (
          ride?.user && (
            <div className="d-flex align-items-center gap-3">
              <ProfilePictureAvatar
                profilePicture={ride?.user?.profilePicture}
                fullName={ride?.user?.fullName}
              />
              <div>
                <Link
                  to={`/users/${ride.user.id}`}
                  className="fw-bold m-0 text-capitalize"
                >
                  {ride.user?.fullName}
                </Link>
              </div>
            </div>
          )
        )}
      </CTableDataCell>

      <CTableDataCell
        className="p-3 text-sm"
        style={{
          minWidth: "350px",
          // overflow: "hidden",
          // textOverflow: "ellipsis",
          whiteSpace: "wrap",
        }}
      >
        <div className="d-flex flex-column gap-2">
          <span>
            <span className="fw-bold">De: </span>
            {ride.pickupLocationName}
          </span>

          <span>
            <span className="fw-bold">À: </span>
            {ride.destinationLocationName}
          </span>
        </div>
      </CTableDataCell>

      {/* <CTableDataCell
        className="p-3 w-75 text-sm"
        style={{
          maxWidth: "200px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "wrap"
        }}
      >
        {ride.destinationLocationName}
      </CTableDataCell> */}

      <CTableDataCell>
        <div className={`p- text-sm d-flex align-items-start flex-column `}>
          <span
            className={
              ride.status === RideStatus.WAITING_PICKUP
                ? "badge-primary"
                : getBadgeClassNameByStatus(ride.status)
            }
          >
            {RideStatusLabels[ride.status as keyof typeof RideStatusLabels]}
          </span>
        </div>
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {paymentMethodHelper(ride?.paymentMethod)}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {metersToKilometers(ride.distance).toFixed(2)}{" "}
        {ride.distance < ONE_KILOMETER ? "m" : "Km"}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {ride.estimatedDuration ? Math.floor(ride.estimatedDuration / 60) : ""}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {ride.originalFare}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">{discountAmount}</CTableDataCell>
      <CTableDataCell className="p-3 text-sm">{ride?.fare}</CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {ride?.metaData?.driverPayment?.paid ? "✅" : "❌"}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {ride?.priceCalculation?.coupon?.isCouponApplied
          ? ride?.metaData?.couponDiscount?.paid
            ? "✅"
            : "❌"
          : "__"}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm ">
        {ride?.metaData?.userBalancePayment?.paid ? "✅" : "❌"}
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {ride.metaData?.validRide === true
          ? "✅"
          : ride.metaData?.validRide === false ||
              [
                RideStatus.ADMIN_CANCELLED,
                RideStatus.DRIVER_CANCELLED,
                RideStatus.USER_CANCELLED,
                RideStatus.NO_DRIVER_FOUND,
              ].indexOf(ride.status as any) !== -1
            ? "❌"
            : "__"}
      </CTableDataCell>
      {/* <CTableDataCell className="p-3 text-sm  align-items-center justify-content-center">
        <Link to={`/rides/${ride?.id}/conversations`} className="text-black">
          <ChatBubbleLeftRightIcon width="25" height="25" />
        </Link>
      </CTableDataCell> */}
      <PromptModal
        open={showModal}
        onAccept={() => removeRide(ride?.id)}
        onClose={() => setShowModal(false)}
      />
    </CTableRow>
  );
}

export default function RidersTable(props: Props) {
  const {
    riders,
    onRiderSelect,
    showDriver = true,
    selectedRides,
    ShowSelectCount = false,
  } = props;
  const [selectCount, setSelectCount] = useState("10");

  const isRideSelectable = (ride: Ride) => {
    if (!ride.metaData?.validRide || ride.status !== RideStatus.COMPLETED) {
      return false;
    }

    const userBalancePaid = ride?.metaData?.userBalancePayment?.paid;
    return !userBalancePaid;
  };

  const selectableRides = riders.filter(isRideSelectable);

  const handleSelectAll = (checked: boolean) => {
    if (!onRiderSelect) return;

    selectableRides.forEach((ride) => {
      onRiderSelect({
        type: checked ? DELETE_ACTIONS.ADD : DELETE_ACTIONS.REMOVE,
        id: ride.id,
      });
    });
  };

  const clearSelections = () => {
    if (!onRiderSelect) return;

    selectedRides?.forEach((id) => {
      onRiderSelect({
        type: DELETE_ACTIONS.REMOVE,
        id,
      });
    });
  };

  const handleSelectCount = (value: string) => {
    setSelectCount(value as any);

    if (!onRiderSelect) return;

    const count = Number(value);

    // RESET OLD SELECTIONS
    clearSelections();

    if (!count || count <= 0) return;

    // Sort selectable rides by createdAt ascending to pick the earliest ones
    const earliestSelectableRides = [...selectableRides].sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    );

    // SELECT FIRST N EARLIEST RIDES
    earliestSelectableRides.slice(0, count).forEach((ride) => {
      onRiderSelect({
        type: DELETE_ACTIONS.ADD,
        id: ride.id,
      });
    });
  };

  const handleSelectCountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setSelectCount(value);
    }
  };

  return (
    <div className="mt-3">
      {ShowSelectCount && (
        <div className="d-flex align-items-center gap-2 mb-3 mr-4">
          <input
            type="number"
            min={1}
            max={selectableRides.length}
            value={selectCount}
            onChange={handleSelectCountChange}
            className="form-control"
            style={{ width: "120px" }}
          />
          <button
            className="btn btn-primary"
            onClick={() => handleSelectCount(selectCount.toString())}
          >
            {Number(selectCount) > 0
              ? ` Sélectionner les ${selectCount} premiers`
              : "Renitialiser la sélection"}
          </button>
        </div>
      )}
      <CTable responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col" className="text-sm">
              {!showDriver && (
                <div className="d-flex align-items-center gap-2">
                  <CFormCheck
                    checked={
                      selectableRides.length > 0 &&
                      selectableRides.every((ride) =>
                        selectedRides?.includes(ride.id),
                      )
                    }
                    indeterminate={
                      selectableRides.some((ride) =>
                        selectedRides?.includes(ride.id),
                      ) &&
                      !selectableRides.every((ride) =>
                        selectedRides?.includes(ride.id),
                      )
                    }
                    disabled={selectableRides.length === 0}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                  {selectedRides && selectedRides.length > 0 && (
                    <span className="text-white rounded-1 bg-primary px-1 w-8 h-8 text-center">
                      {selectedRides.length}{" "}
                      {/* {selectedRides.length === 1
                        ? "sélectionné"
                        : "sélectionnés"} */}
                    </span>
                  )}
                </div>
              )}
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Référence du trajet
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Date du trajet
              </div>
            </CTableHeaderCell>
            {showDriver && (
              <CTableHeaderCell scope="col" className="text-sm">
                <div className="d-flex align-items-center justify-content-between">
                  Chauffeur
                </div>
              </CTableHeaderCell>
            )}
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Client
              </div>
            </CTableHeaderCell>

            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Localisation et Destination
              </div>
            </CTableHeaderCell>
            {/* <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Destination
              </div>
            </CTableHeaderCell> */}
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Statut
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm ">
              <div className="d-flex align-items-center justify-content-between">
                Moyen de paiement
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Distance
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Durée estimée (min)
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Frais originaux (MAD)
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Montant du coupon (MAD)
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Montant payé (MAD)
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Bonus Payé ?
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Coupon Payé ?
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm ">
              <div className="d-flex align-items-center justify-content-between">
                User Solde Payé ?
              </div>
            </CTableHeaderCell>
            <CTableHeaderCell scope="col" className="text-sm">
              <div className="d-flex align-items-center justify-content-between">
                Le trajet est-il valid ?
              </div>
            </CTableHeaderCell>

            {/* <CTableHeaderCell
              scope="col"
              className="text-sm"
            ></CTableHeaderCell> */}
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {riders?.map((ride) => (
            <TableBodyRowContent
              key={ride.id}
              ride={ride}
              deletedList={onRiderSelect!}
              showDriver={showDriver}
              selectedRides={selectedRides!}
            />
          ))}
        </CTableBody>
      </CTable>
    </div>
  );
}
